import { Box, Typography } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'services/constants/tableStructureTypes';
import { getPpwrPackingTypesRequest } from 'redux/reducers/ppwr/reducer';
import { getPpwrPackingTypes, getPpwrPackingTypesIsLoading } from 'redux/reducers/ppwr/selectors';
import {
	PPWR_PACKING_TYPE_ACTIONS,
	tableStructure,
	TPpwrPackingTypeTableRow,
} from './tableStructure';
import { EditWeightDialog } from './EditWeightDialog';
import { COLORS } from 'services/constants/colors';

const ROWS = Array.from(new Array(5));

export const PpwrPackingTypes: FC = () => {
	const dispatch = useDispatch();
	const packingTypes = useSelector(getPpwrPackingTypes);
	const packingTypesIsLoading = useSelector(getPpwrPackingTypesIsLoading);

	useEffect(() => {
		dispatch(getPpwrPackingTypesRequest());
	}, [dispatch]);

	const easTableItems = useMemo(() => {
		const rows: TPpwrPackingTypeTableRow[] = (packingTypes ?? []).map((packingType) => ({
			id: packingType.id,
			name: packingType.name ?? '',
			handler: packingType.handler ?? '',
			examples: packingType.examples ?? '',
			proofRequired: packingType.proofRequired,
			enabled: packingType.enabled,
			weight: packingType.weight !== null ? String(packingType.weight) : '',
			weightProductPack:
				packingType.weightProductPack !== null && packingType.weightProductPack !== undefined
					? String(packingType.weightProductPack)
					: '',
			documentsCount: String(packingType.documents?.length ?? 0),
			dashboardUpdatedAt: packingType.dashboardUpdatedAt,
			dashboardUpdatedBy:
				packingType.dashboardUpdatedBy?.fullName ?? packingType.dashboardUpdatedBy?.email ?? '',
		}));
		return { data: rows, totalCount: rows.length };
	}, [packingTypes]);

	// Index (within `packingTypes`) of the row edited in the weight dialog.
	const [editIndex, setEditIndex] = useState<number | null>(null);

	const handleAction: THandleAction = (id, type) => {
		if (type !== PPWR_PACKING_TYPE_ACTIONS.EDIT_WEIGHT) return;
		const index = (packingTypes ?? []).findIndex((packingType) => packingType.id === id);
		if (index !== -1) setEditIndex(index);
	};

	return (
		<>
			<EasTableWithoutFilter<TPpwrPackingTypeTableRow>
				tableStructure={tableStructure}
				items={easTableItems}
				itemsIsLoading={packingTypesIsLoading}
				handleAction={handleAction}
				skeletonRows={ROWS}
				highlightedRow={null}
				paginationBlock={false}
			>
				<Box sx={{ p: '2px 4px' }}>
					<Typography sx={{ fontSize: '1.2rem', color: COLORS.PRIMARY, fontWeight: 'bold' }}>
						ERP/PPWR Packing Profile
					</Typography>
				</Box>
			</EasTableWithoutFilter>
			<EditWeightDialog
				rows={packingTypes ?? []}
				index={editIndex}
				setIndex={setEditIndex}
				onClose={() => setEditIndex(null)}
			/>
		</>
	);
};
